import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GqlClientGetAutocompleteOptionsParams } from "~/__generated__";

import { ClientSelect_GetAutocompleteOptionsDocument } from "../queries.generated";

export default function useClientSelect_GetAutocompleteOptions(params: GqlClientGetAutocompleteOptionsParams) {
    const { data, previousData, loading } = useQuery(ClientSelect_GetAutocompleteOptionsDocument, {
        variables: { params },
    });

    const options = useMemo(() => data?.clientGetAutocompleteOptions.data ?? [], [data]);
    const selectedOptions = useMemo(
        () => (data ?? previousData)?.clientGetAutocompleteOptions.selectedData ?? [],
        [data, previousData],
    );

    return { options, selectedOptions, loading };
}
